import React, { useState } from "react";
import web from "../Assets/Images/web.png";
import calender from "../Assets/Images/calender.png";
import credit from "../Assets/Images/credit.png";
import sell from "../Assets/Images/sell.png";
import cottage from "../Assets/Images/cottage.png";
import { Parser } from "html-to-react";
import { timeformatter } from "../utils/dateformatter";
import { formatAmount } from "../utils/formatAmount";

const AboutRealEstate = ({ state }) => {
  const htmlParser = new Parser();

  const [readAll, setReadAll] = useState(false);
  return (
    <div className=" p-y-5 mb-[20px] w-full lg:max-w-[609px] ">
      <div className="mb-[20px] lg:w-[609px] lg:h-[454px] ">
        <img
          src={state?.properties_images[0]}
          alt=""
          className=" w-full lg:w-[609px] lg:h-[454px] rounded-[12px] object-cover"
        />
      </div>
      <div className=" flex mb-[10px] justify-between items-center ">
        <div className=" text-[16px] font-[500] text-[#131E3D] ">About</div>
        <div className=" flex items-center gap-[5px] ">
          <div className="cursor-not-allowed text-[#6935D3] text-[16px] font-[400]">
            Share with friends
          </div>
          <img src={web} alt="" className=" w-[20px] h-[20px] " />
        </div>
      </div>
      <div className=" h-[0.5px] w-full bg-[#F2F2F7] "></div>

      <div className=" mt-[10px] ">
        <h4 className="">
          <span
            className={`  ${
              readAll ? "" : "line-clamp-2"
            } text-[#9C9C9E] text-[16px] font-[400] `}
          >
            {state?.description && state?.description !== "null"
              ? htmlParser?.parse(state?.description)
              : ""}{" "}
          </span>
        </h4>
        {state?.description?.length > 120 ? (
          <h4
            onClick={() => {
              setReadAll((prev) => !prev);
            }}
            className="cursor-pointer  text-right w-full text-[#6935D3]"
          >
            {readAll ? "Show Less." : "Read More."}
          </h4>
        ) : (
          <></>
        )}
      </div>

      <div className=" mt-[20px] flex gap-[8px] ">
        <div className="  hover:text-[#6935D3] gap-[5px] bg-[#F2F2F7] min-w-[104px] font-[400] text-[14px] text-[#131E3D]  h-[33px] rounded-[40px] p-4 flex items-center justify-center ">
          <img src={cottage} alt="" className=" w-[16px] h-[16px] " />
          {state?.type}
        </div>
        <div className=" hover:text-[#6935D3]  bg-[#F2F2F7] min-w-[104px] font-[400] text-[14px] text-[#131E3D] h-[33px] rounded-[40px] p-4 flex items-center justify-center ">
          {state?.features}
        </div>
        {/* <div className="  hover:text-[#6935D3] bg-[#F2F2F7] w-[83px] font-[400] text-[14px] text-[#131E3D] h-[33px] rounded-[40px] p-4 flex items-center justify-center ">
          Rental{" "}
        </div> */}
      </div>

      <div className="  mx-auto w-full  ">
        <div className="flex mt-[40px]  justify-between">
          <div className="flex gap-[6px]  items-center">
            <img src={calender} alt="" className=" w-[18px] h-[18px] " />
            <div className=" text-[16px] font-[400] text-[#9C9C9E] ">
              {" "}
              Listing Date{" "}
            </div>
          </div>
          <div className=" text-[#131E3D] text-[16px] font-[400] ">
            {" "}
            {timeformatter(state?.created_at, "formal", false, true)}{" "}
          </div>
        </div>
        <div className=" mt-[10px] w-full bg-[#F2F2F7] h-[1.5px]  "></div>
      </div>

      <div className=" mx-auto w-full ">
        <div className="flex mt-[10px] items-center  justify-between">
          <div className=" flex gap-[6px] items-center ">
            <img src={credit} alt="" className=" w-[18px] h-[18px] " />
            <div className=" text-[16px] font-[400] text-[#9C9C9E] ">
              {" "}
              Available Units{" "}
            </div>
          </div>
          <div className=" text-[#131E3D] text-[16px] font-[400] ">
            {state?.total_units
              ? formatAmount(
                  state?.total_units -
                    Number(state?.total_amount_invested || 0) /
                      Number(state?.amount_per_unit || 0)
                )
              : "-"}
          </div>
        </div>
        <div className=" mt-[10px] w-full bg-[#F2F2F7] h-[1.5px]  "></div>
      </div>

      <div className=" mx-auto w-full ">
        <div className="flex mt-[10px]  justify-between">
          <div className=" flex gap-[6px] items-center ">
            <img src={sell} alt="" className="w-[18px] h-[18px] " />
            <div className=" text-[16px] font-[400] text-[#9C9C9E] ">
              {" "}
              Target annual rental{" "}
            </div>
          </div>
          <div className=" text-[#131E3D] text-[16px] font-[400] ">
            {" "}
            {state?.annual_roi}%{" "}
          </div>
        </div>
        <div className=" mt-[10px] w-full bg-[#F2F2F7] h-[1.5px]  "></div>
      </div>
    </div>
  );
};

export default AboutRealEstate;
